import { Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Divider = styled(Image)`
  height: 3px;
  left: 11%;
  position: absolute;
  top: 36%;
  width: 235px;
`;

const GiftCollection = styled(Image)`
  bottom: 6%;
  left: 15%;
  position: absolute;
  width: 210px;
`;

const CollectionDescription = styled.div`
  -ms-overflow-style: none;
  background-color: var(--color-bg-body);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  height: calc(100% - 42px);
  margin: 43px auto 0;
  padding: 16px;
  width: 100%;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari Opera */
  }
`;

const DescriptionPlaceHolder = styled(Typography)`
  text-transform: lowercase;
  width: 100%;
`;

const Description = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 140px;
  text-align: center;
  width: 100%;
`;

const DescriptionTitle = styled(Typography)``;

const DescriptionText = styled(Typography)`
  height: 110px;
  margin-top: 10px;
  overflow-y: auto;
  text-align: center;
  width: 210px;
`;

export {
  CollectionDescription,
  Description,
  DescriptionPlaceHolder,
  DescriptionText,
  DescriptionTitle,
  Divider,
  GiftCollection
};
